import { createAction } from "@reduxjs/toolkit";
import type { CreateProviderStudioBody } from "@shared-kernel/application/ports/provider/provider-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const createProviderStudio = createApiThunk<string, CreateProviderStudioBody>(
  "provider/studio/create",
  async (body, { extra: { providerRepository } }) => {
    return providerRepository!.createStudio(body);
  },
);

export const resetCreateProviderStudio = createAction("provider/studio/resetCreate");
